import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_ACTION_QUEUE_API } from "./apiRoutes";

interface Props {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getActionQueue = async () => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_ACTION_QUEUE_API}`);
};

const useGetActionQueue = ({ queryParams }: Props = {}): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-action-queue"],
    queryFn: () => getActionQueue(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetActionQueue;
